module.exports = __webpack_public_path__ + "static/img/port-bg01.a49998b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution/port-bg01.jpg
// module id = 4JyQ
// module chunks = 7